// extracted by mini-css-extract-plugin
export default {"root":"StuTable_root__cK4Qh","student":"StuTable_student__fQUKj","stuName":"StuTable_stuName__ae5BY","stuNo":"StuTable_stuNo__YLvko"};